import React from 'react';

function AvatarPlaceholder({ placeholderText, className, fontSize }) {
	return (
		<div className={`ProfileImage PlaceholderProfileImage ${className || ''}`}>
			<span className="placeholder-text" style={{ fontSize: `${fontSize}px` }}>
				{placeholderText}
			</span>
		</div>
	);
}

export class ProfileImage extends React.Component {
	isURLAbsolute(url) {
		return url.indexOf('://') > 0 || url.indexOf('//') === 0;
	}
	buildAbsoluteURL(url) {
		return `${process.env.REACT_APP_API}${url}`;
	}
	getPlaceholderText() {
		const { placeholderText, name } = this.props;
		if (placeholderText) return placeholderText;
		if (name) return name.charAt(0).toUpperCase();
		return 'C';
	}
	getFontSize() {
		const { size } = this.props;
		return size ? Math.max(10, Math.round(size * 0.5)) : 10;
	}
	render() {
		const hasProfileImage = !!this.props.src;

		return hasProfileImage ? (
			<img
				alt="avatar"
				className={`ProfileImage ${this.props.className || ''}`}
				src={
					!this.isURLAbsolute(this.props.src)
						? this.buildAbsoluteURL(this.props.src)
						: this.props.src
				}
			/>
		) : (
			<AvatarPlaceholder
				placeholderText={this.getPlaceholderText()}
				className={this.props.className}
				fontSize={this.getFontSize()}
			/>
		);
	}
}
